import { createApi } from "@reduxjs/toolkit/query/react";
import { tokenQuery } from "./tokenQuery";

const sitesAndActivitiesAPI = createApi({
    reducerPath: "sitesAndActivitiesAPI",
    baseQuery: tokenQuery,
    endpoints: (builder) => ({
        getListOfSitesAndActivities: builder.mutation({
            query: ({staffId}) => {
                let url = staffId
                    ? `tour-calculation/get/sites-acts/dropdown-data/${staffId}`
                    : `tour-calculation/get/sites-acts/dropdown-data/undefined`;

                return {
                    url,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        getSelectedSitesAndActivityDetails: builder.mutation({
            query: ({activityIds, siteIds, staffId}) => {
                const params = {
                    'activityIds': activityIds,
                    'siteIds': siteIds,
                };
                if(staffId){
                    params['staffId'] = staffId;
                }
                const queryParams = new URLSearchParams(params);

                const apiUrl = `tour-calculation/get/site-act/fees?${queryParams.toString()}`;

                return {
                    url: apiUrl,
                    method: "GET"
                };
            },
            transformResponse: (response) => response
        }),

        getAllSavedActivityAndSite: builder.mutation({
            query: ({staffId, page, size, searchKey, fromDate, toDate}) => {
                let url = `sites-activities/get-all?page=${page}&size=${size}`;

                if(staffId){
                    url += `&staffId=${staffId}`
                }

                if(searchKey){
                    url += `&searchKey=${searchKey}`
                }

                if(fromDate){
                    url += `&fromDate=${fromDate}`
                }

                if(toDate){
                    url += `&toDate=${toDate}`
                }

                const apiUrl = url;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        getSavedActivityAndSiteByID: builder.mutation({
            query: ({id}) => {
                const apiUrl = `sites-activities/get/by-id/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        saveActivityAndSite: builder.mutation({
            query: ({body}) => {
                const apiUrl = `sites-activities/create`;

                return {
                    url: apiUrl,
                    method: "POST",
                    body: body
                };
            },
            transformResponse: (response) => response
        }),
        editActivityAndSite: builder.mutation({
            query: ({body}) => {
                const apiUrl = `sites-activities/update`;

                return {
                    url: apiUrl,
                    method: "PUT",
                    body
                };
            },
            transformResponse: (response) => response
        }),
        deleteActivityAndSite: builder.mutation({
            query: ({id, staffId}) => {
                let url = `sites-activities/delete/${id}`;
                if(staffId){
                    url += `?staffId=${staffId}`
                }
                return {
                    url,
                    method: "DELETE"
                };
            },
            transformResponse: (response) => response
        })
    })
});

export const { 
    useGetListOfSitesAndActivitiesMutation,
    useGetSelectedSitesAndActivityDetailsMutation,

    useGetAllSavedActivityAndSiteMutation,
    useGetSavedActivityAndSiteByIDMutation,
    useSaveActivityAndSiteMutation,
    useEditActivityAndSiteMutation,
    useDeleteActivityAndSiteMutation
} = sitesAndActivitiesAPI;

export default sitesAndActivitiesAPI;